import { useEffect } from 'react';
import { useRouter } from 'next/router';

const ROOT_MARGIN = '0px 0px -25% 0px';
const HOST_SELECTOR = '[data-af-anim]:not([data-af-in])';

export function AnimationObserver() {
  const router = useRouter();

  useEffect(() => {
    const revealAll = () => {
      document.querySelectorAll(HOST_SELECTOR).forEach((host) => host.setAttribute('data-af-in', ''));
    };

    if (typeof IntersectionObserver === 'undefined') {
      revealAll();
      return;
    }

    const targetToHost = new Map<Element, Element>();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const host = targetToHost.get(entry.target);
          if (host) host.setAttribute('data-af-in', '');
          observer.unobserve(entry.target);
          targetToHost.delete(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0 },
    );

    const scan = () => {
      document.querySelectorAll(HOST_SELECTOR).forEach((host) => {
        const target = host.firstElementChild ?? host;
        if (targetToHost.has(target)) return;
        targetToHost.set(target, host);
        observer.observe(target);
      });
    };

    scan();
    const rescan = window.setTimeout(scan, 800);

    const events = router.events;
    events?.on?.('routeChangeComplete', scan);

    return () => {
      observer.disconnect();
      targetToHost.clear();
      window.clearTimeout(rescan);
      events?.off?.('routeChangeComplete', scan);
    };
  }, [router.events]);

  return null;
}
